import http from "../http-common";

class SportsTicketsService {
  // Create a new sports ticket event with bulk tickets
  create(data) {
    return http.post("/v1/sports-tickets", data);
  }

  // Add users to an existing sports ticket event in chunks
  addUsers(data) {
    return http.post(`/v1/sports-tickets/${data.ticketId}/users`, data.users);
  }

  // Retrieve all sports ticket events
  getAll() {
    return http.get("/v1/sports-tickets");
  }

  // Retrieve a single sports ticket event with its individual tickets
  get(id) {
    return http.get(`/v1/sports-tickets/${id}`);
  }

  // Delete a sports ticket event and all associated individual tickets and users
  delete(id) {
    return http.delete(`/v1/sports-tickets/${id}`);
  }

  // Get individual ticket details by QR code
  getByQrCode(qrCode) {
    return http.get(`/v1/sports-tickets/qr/${qrCode}`);
  }

  // Mark an individual ticket as used
  markAsUsed(id) {
    return http.put(`/v1/sports-tickets/individual/${id}/used`);
  }
}

export default new SportsTicketsService();
